import { render, staticRenderFns } from "./TabbedNav.vue?vue&type=template&id=772db956&scoped=true&"
import script from "./TabbedNav.vue?vue&type=script&lang=ts&"
export * from "./TabbedNav.vue?vue&type=script&lang=ts&"
import style0 from "./TabbedNav.vue?vue&type=style&index=0&id=772db956&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772db956",
  null
  
)

export default component.exports